import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import TrustBand from "@/components/TrustBand";
import SEOHead from "@/components/SEOHead";

const AboutSection = lazy(() => import("@/components/AboutSection"));
const ProductCatalog = lazy(() => import("@/components/ProductCatalog"));
const SocialProof = lazy(() => import("@/components/SocialProof"));
const HowItWorks = lazy(() => import("@/components/HowItWorks"));
const PreOrderForm = lazy(() => import("@/components/PreOrderForm"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const Footer = lazy(() => import("@/components/Footer"));
const StickyMobileCTA = lazy(() => import("@/components/StickyMobileCTA"));
const CookieConsent = lazy(() => import("@/components/CookieConsent"));
const InterestPopup = lazy(() => import("@/components/InterestPopup"));
const CountdownSection = lazy(() => import("@/components/CountdownSection"));
const CountdownPopup = lazy(() => import("@/components/CountdownPopup"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBand />
        <Suspense fallback={null}>
          <section id="om-oss" aria-label="Om Fuegos JL Nordic">
            <AboutSection />
          </section>
          <ProductCatalog />
          <SocialProof />
          <CountdownSection />
          <section id="slik-bestiller-du" aria-label="Slik bestiller du">
            <HowItWorks />
          </section>
          <PreOrderForm />
          <FAQSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <StickyMobileCTA />
        <InterestPopup />
        <CountdownPopup />
        <CookieConsent />
      </Suspense>
    </div>
  );
};

export default Index;
